import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Dropdown,
  ButtonGroup,
  Form,
  Alert,
  Modal,
} from "react-bootstrap";
import { IoMdInformationCircle } from "react-icons/io";
import { FaCalendarAlt } from "react-icons/fa";
import { MdEditNotifications, MdAddchart } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import "./holidays.css";

export default function PublicHolidays() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [showAlert, setShowAlert] = useState(false); // Alert state for delete confirmation
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [holidayIdToDelete, setHolidayIdToDelete] = useState(null); // ID of holiday to delete
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  // Fetch holidays data on component mount and when search query changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching holidays with search query:", searchQuery);  // Log the search query being used
        const response = await axios.get(
          "https://backend.ems.hiradentallab.com/api/holidays/get",
          {
            params: { search: searchQuery },  // Send search query to the backend
          }
        );
        console.log("Fetched Data:", response.data);  // Log the data fetched from the backend
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [searchQuery]);  // Run this whenever searchQuery changes

  // Handle form input change for search
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);  // Update the search query
  };

  // Prevent form submission and page reload
  const handleSubmit = (event) => {
    event.preventDefault();  // Prevent form default behavior (page reload)
  };

  // Handle holiday deletion
  const handleDelete = async () => {
    if (holidayIdToDelete) {
      try {
        const response = await axios.delete(
          `https://backend.ems.hiradentallab.com/api/holidays/${holidayIdToDelete}`
        );
        if (response.status === 200) {
          // Remove the deleted holiday from the data array
          setData(data.filter((holiday) => holiday._id !== holidayIdToDelete));
          setShowAlert(true); // Show the success alert
          setShowModal(false); // Close the delete confirmation modal

          // Hide the alert automatically after a few seconds
          setTimeout(() => setShowAlert(false), 3000); // 3000 ms = 3 seconds
        }
      } catch (error) {
        console.error(
          "Error deleting holiday:",
          error.response ? error.response.data : error.message
        );
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageRange = () => {
    const totalPages = Math.ceil(data.length / rowsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  };

  return (
    <div className="container-fluid">
      <h1 className="holiday-title">
        <IoMdInformationCircle /> Public Holidays Information
      </h1>
      <hr />
      <h1 className="holiday-subtitle">
        <FaCalendarAlt /> Public Holidays
      </h1>
      <hr />
      {showAlert && (
        <Alert
          variant="success"
          onClose={() => setShowAlert(false)}
          dismissible
        >
          Holiday deleted successfully!
        </Alert>
      )}
      <div className="emp-info-content">
        <Link to="/add-holiday">
          <Button variant="primary" className="add-emp-button">
            <MdAddchart className="button-icon" /> Add Holidays
          </Button>
        </Link>
        <div className="emp-info-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item>10</Dropdown.Item>
                  <Dropdown.Item>25</Dropdown.Item>
                  <Dropdown.Item>50</Dropdown.Item>
                  <Dropdown.Item>100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className="search-container">
                 <Form className="d-flex" onSubmit={handleSubmit}>
        <Form.Control
          type="search"
          placeholder="Search by holiday name"
          aria-label="Search"
          className="holiday-search"
          value={searchQuery}  // Bind search input value
          onChange={handleSearchChange}  // Update search query on change
        />
      </Form>
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="table table-striped table-style">
              <thead className="holidays-table-header">
                <tr className="table-header">
                  <th>SR</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Pay Rate</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
            {data.length > 0 ? (
              data
                .slice(
                  (currentPage - 1) * rowsPerPage,
                  currentPage * rowsPerPage
                )
                .map((holiday, index) => (
                  <tr key={holiday._id} style={{ textAlign: "center" }}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{holiday.holidayName}</td>
                    <td>{new Date(holiday.date).toLocaleDateString()}</td>
                    <td>{holiday.payRate}</td>
                    <td>
                      <Link to={`/edit-public-holidays/${holiday._id}`}>
                        <Button variant="warning" size="sm">
                          <MdEditNotifications />
                        </Button>
                      </Link>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                          // Show modal to delete holiday (your modal code)
                        }}
                      >
                        <RiDeleteBin5Line />
                      </Button>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="5">No data available</td>
              </tr>
            )}
          </tbody>
              <tfoot className="table-footer">
                <tr className="holiday-table-footer">
                  <td>Total</td>
                  <td>-</td>
                  <td>{data.length}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          )}
          {/* Pagination */}
          <div className="pagination-row">
            <div className="entries-info">
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
              {data.length} entries
            </div>
            <nav>
              <ul className="pagination no-gap">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>
                {pageRange().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      currentPage === pageNumber ? "active" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === Math.ceil(data.length / rowsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this holiday?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
